// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FlightListCard {
  margin-top: 10px;
  width: 453px;
}
.FlightListCard .product-box {
  padding: 0;
  border: 1px solid #e7eaec;
}
.FlightListCard .product-box.active {
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
}
@media screen and (max-width: 451px) {
  .FlightListCard .product-box.active {
    box-shadow: none;
  }
}
.FlightListCard .product-imitation {
  text-align: center;
  padding: 6px 0;
}
.FlightListCard .product-imitation img {
  /*height: 160px;*/
  width: 100%;
  height: 199px;
  object-fit: cover;
}
.FlightListCard .product-header {
  margin-bottom: 10px;
}
.FlightListCard .product-header .header-img-1 img {
  width: 50%;
}
.FlightListCard .header-img-2 {
  cursor: pointer;
  width: fit-content;
  margin-left: auto;
}
.FlightListCard .header-img-2 img {
  width: 20px;
  height: 20px;
  vertical-align: text-top;
  margin-right: 11px;
}
.FlightListCard span.header-img-2 span {
  vertical-align: top;
  padding-left: 2px;
  vertical-align: top;
  padding-left: 2px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #694779;
  opacity: 0.8;
}
.FlightListCard .product-name {
  font-family: "FKGroteskNeue-Regular";
  font-style: normal;
  font-weight: 700;
  font-size: 19px;
  line-height: 31px;
  color: #000000;
  padding-bottom: 20px;
}
.FlightListCard .product-deatils-col span {
  width: 19px;
  flex: none;
  flex-grow: 0;
  margin-right: 18px;
  font-size: 11.2px;
}
@media screen and (max-width: 575px) {
  .FlightListCard .product-bottom {
    padding-top: 0px !important;
  }
  .FlightListCard .product-deatils-col span {
    font-size: 15px;
  }
  .FlightListCard .product-deatils-col {
    font-size: 15px !important;
  }
  .FlightListCard .product-bottom span {
    font-size: 14px !important;
    line-height: 18px !important;
  }
}
.FlightListCard .product-deatils-col span img {
  filter: invert(0%) brightness(0%);
  margin-bottom: 3px;
}
.FlightListCard .product-desc {
  padding: 20px 0px 15px 11px;
  position: relative;
}
.FlightListCard .product-bottom {
  clear: both;
  display: flex;
  margin-left: 9px;
  padding-top: 7px;
}
.FlightListCard .product-deatils {
  width: 100%;
}
.FlightListCard .product-deatils-col {
  width: 50%;
  float: left;
  font-family: "FKGroteskNeue-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #000000;
  flex: none;
  order: 1;
  flex-grow: 0;
  height: 26px;
  margin-bottom: 18px;
}
.FlightListCard .product-bottom span {
  font-family: "FKGroteskNeue-Regular";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #694779;
  cursor: pointer;
  letter-spacing: 0.2px;
}
.FlightListCard .product-bottom button {
  background: #ffffff;
  border: 1px solid #694779;
  border-radius: 70px;
}
.FlightListCard .ecommerce .tag-list {
  padding: 0;
}
.FlightListCard .ecommerce .fa-star {
  color: #d1dade;
}
.FlightListCard .ecommerce .fa-star.active {
  color: #f8ac59;
}
.FlightListCard .ecommerce .note-editor {
  border: 1px solid #e7eaec;
}
.FlightListCard table.shoping-cart-table {
  margin-bottom: 0;
}
.FlightListCard table.shoping-cart-table tr td {
  border: none;
  text-align: right;
}
.FlightListCard table.shoping-cart-table tr td.desc,
.FlightListCard table.shoping-cart-table tr td:first-child {
  text-align: left;
}
.FlightListCard table.shoping-cart-table tr td:last-child {
  width: 80px;
}
.FlightListCard .product-detail .ibox-content {
  padding: 30px 30px 50px 30px;
}
.FlightListCard .image-imitation {
  background-color: #f8f8f9;
  text-align: center;
  padding: 200px 0;
}
.FlightListCard .ibox {
  clear: both;
  margin-bottom: 25px;
  margin-top: 0;
  padding: 0;
}
@media screen and (max-width: 451px) {
  .FlightListCard .ibox {
    margin-bottom: 0px;
  }
}
.FlightListCard .ibox.collapsed .ibox-content {
  display: none;
}
.FlightListCard .ibox:after,
.FlightListCard .ibox:before {
  display: table;
}
.FlightListCard .ibox-title {
  -moz-border-bottom-colors: none;
  -moz-border-left-colors: none;
  -moz-border-right-colors: none;
  -moz-border-top-colors: none;
  background-color: #ffffff;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 3px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}
.FlightListCard .ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 0px 20px;
  border-color: #e7eaec;
  border-image: none;
}
@media screen and (max-width: 575px) {
  .FlightListCard .ibox-content {
    padding: 15px 16px 0px 16px;
  }
  .FlightListCard .product-header {
    margin-bottom: 3px;
    margin-top: -5px;
  }
  .FlightListCard .product-desc {
    padding: 9px 0px 9px 11px;
  }
}
.FlightListCard .ibox-footer {
  color: inherit;
  border-top: 1px solid #e7eaec;
  font-size: 90%;
  background: #ffffff;
  padding: 10px 15px;
}

.popover-positioned-top {
  border: none !important;
}
.popover-positioned-top .pop-top {
  margin-bottom: 30px;
}
.popover-positioned-top .pop-top .popover-title {
  font-size: 20px;
  font-weight: 700;
}
.popover-positioned-top .popover-body {
  min-width: 549px;
  padding: 0;
  border: none;
  margin: 0;
}
.popover-positioned-top .popover-con {
  padding: 30px;
  background: #ffffff;
  border: 1px solid transparent;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
  min-width: 549px;
  margin-left: 75px;
}
.popover-positioned-top .top-name {
  font-family: "FKGroteskNeue-Regular";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 31px;
  display: flex;
  align-items: center;
  color: #000000;
  float: left;
}
.popover-positioned-top .top-tail {
  float: right;
  font-family: "FKGroteskNeue-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #848b94;
  flex-direction: row-reverse;
}
.popover-positioned-top .pop-top {
  padding-bottom: 10px;
}
.popover-positioned-top .pop-middle {
  padding-bottom: 15px;
}
.popover-positioned-top .pop-body {
  font-family: "FKGroteskNeue-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #000;
  display: flex;
  flex-wrap: wrap;
  column-gap: 30px;
  row-gap: 10px;
}
.popover-positioned-top .pop-body > .details-item {
  width: 45%;
}
.popover-positioned-top label.lbltxt {
  width: 50%;
  float: left;
  margin-bottom: 0;
}
.popover-positioned-top span.lblval {
  float: right;
}

@media screen and (max-width: 451px) {
  .FlightListCard {
    padding: 15px;
    padding-bottom: 0px;
  }
  .popover-positioned-top {
    z-index: 1 !important;
  }
  .popover-positioned-top .popover-body {
    min-width: 100%;
  }
  .popover-positioned-top .popover-con {
    padding: 23px;
    min-width: 100%;
    margin-left: 15px !important;
  }
}
@media screen and (min-width: 451px) and (max-width: 575px) {
  .popover-positioned-top .popover-con {
    margin-left: 20px !important;
    min-width: 0px;
    width: 360px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1439px) {
  .popover-positioned-top .popover-con {
    margin-left: 20px !important;
  }
}
@media screen and (min-width: 451px) and (max-width: 800px) {
  .FlightListCard .product-name {
    font-size: 18px;
  }
  .FlightListCard .product-header .header-img-1 img {
    width: 50%;
  }
  .FlightListCard .Button.small-btn {
    font-size: 12px;
  }
}
@media screen and (min-width: 576px) and (max-width: 850px) {
  .popover-positioned-top .popover-con {
    padding: 23px;
    margin-left: 75px !important;
    max-width: 360px;
    min-width: 0px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  .FlightListCard .product-deatils-col {
    font-size: 11px;
  }
}
.product-details-color {
  color: #000000;
}

@media screen and (max-width: 575px) {
  .max-passengers-span-style {
    margin-bottom: 6px !important;
  }
  .max-passengers-width {
    width: 26px !important;
    height: 16px !important;
  }
  .wifi-icon-width {
    width: 23px !important;
    height: 16px !important;
  }
  .currency-img-padding {
    padding-left: 11px;
    margin-bottom: 0px !important;
  }
  .product-deatils-col {
    margin-right: -40px;
  }
  .currency-vector-mob-margin {
    margin-right: 16px !important;
  }
  .popover-positioned-top .pop-body > .details-item {
    width: 100%;
  }
}
.letter-spacing-style {
  letter-spacing: 0.1px;
  font-size: 14px !important;
  font-weight: 600;
}

@media screen and (min-width: 1200px) {
  .product-deatils-col {
    margin-right: -49px;
  }
}
@media screen and (min-width: 1200px) {
  .span-margin-style {
    margin-right: 15px !important;
    margin-top: 2px;
    font-size: 14px !important;
  }
}
@media screen and (min-width: 1200px) {
  .product-name {
    font-size: 24px !important;
  }
}
@media screen and (min-width: 1200px) {
  .max-passengers-span-style {
    font-size: 16px !important;
  }
}
.popover-positioned-top {
  background-color: transparent !important;
}

@media screen and (min-width: 768px) and (max-width: 820px) {
  .FlightListCard .product-name {
    font-size: 20px !important;
  }
  .FlightListCard .product-deatils-col {
    font-size: 16px !important;
  }
  .FlightListCard .product-deatils-col span {
    font-size: 13px;
  }
}
@media screen and (min-width: 891px) and (max-width: 1024px) {
  .FlightListCard .product-name {
    font-size: 17px;
  }
}
@supports (-webkit-touch-callout: none) {
  @media (min-width: 1200px) {
    .product-name {
      font-size: 20px !important;
    }
    .trip-estimate-title {
      font-size: 20px !important;
    }
    .TripSummary .subtitile-h4 {
      font-size: 18px !important;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/ChooseAFlight/FlightListCard/FlightListCard.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAGA;EACE,gBAAA;EACA,YAAA;AAFF;AAKE;EACE,UAAA;EACA,yBAAA;AAHJ;AAME;EAIE,6CAAA;AALJ;AAOE;EACE;IACE,gBAAA;EALJ;AACF;AAOE;EACE,kBAAA;EACA,cAAA;AALJ;AAOE;EACE,iBAAA;EAEA,WAAA;EACA,aAAA;EACA,iBAAA;AANJ;AAQE;EACE,mBAAA;AANJ;AAQE;EAGE,UAAA;AARJ;AAUE;EAEE,eAAA;EACA,kBAAA;EACA,iBAAA;AATJ;AAWE;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;AATJ;AAWE;EACE,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AATJ;AAWE;EACE,oCCnDW;EDoDX,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;AATJ;AAWE;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AATJ;AAWE;EACE;IACE,2BAAA;EATJ;EAWE;IACE,eAAA;EATJ;EAWE;IACE,0BAAA;EATJ;EAWE;IACE,0BAAA;IACA,4BAAA;EATJ;AACF;AAWE;EACE,iCAAA;EACA,kBAAA;AATJ;AAWE;EACE,2BAAA;EACA,kBAAA;AATJ;AAWE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AATJ;AAWE;EACE,WAAA;AATJ;AAWE;EACE,UAAA;EACA,WAAA;EACA,oCCrGW;EDsGX,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AATJ;AAWE;EACE,oCCpHW;EDqHX,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AATJ;AAWE;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;AATJ;AAuBE;EACE,UAAA;AArBJ;AAuBE;EACE,cAAA;AArBJ;AAuBE;EACE,cAAA;AArBJ;AAuBE;EACE,yBAAA;AArBJ;AAuBE;EACE,gBAAA;AArBJ;AAuBE;EACE,YAAA;EACA,iBAAA;AArBJ;AAuBE;;EAEE,gBAAA;AArBJ;AAuBE;EACE,WAAA;AArBJ;AAuBE;EACE,4BAAA;AArBJ;AAuBE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AArBJ;AAwBE;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;AAtBJ;AAwBE;EACE;IACE,kBAAA;EAtBJ;AACF;AAwBE;EACE,aAAA;AAtBJ;AAyBE;;EAEE,cAAA;AAvBJ;AAyBE;EACE,+BAAA;EACA,6BAAA;EACA,8BAAA;EACA,4BAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,8BAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AAvBJ;AAyBE;EACE,yBAAA;EACA,cAAA;EACA,2BAAA;EACA,qBAAA;EACA,kBAAA;AAvBJ;AAyBE;EACE;IACE,2BAAA;EAvBJ;EAyBE;IACE,kBAAA;IACA,gBAAA;EAvBJ;EAyBE;IACE,yBAAA;EAvBJ;AACF;AAyBE;EACE,cAAA;EACA,6BAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAvBJ;;AA2BA;EACE,uBAAA;AAxBF;AAyBE;EAEE,mBAAA;AAxBJ;AA0BE;EACE,eAAA;EACA,gBAAA;AAxBJ;AA0BE;EACE,gBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;AAxBJ;AA0BE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EAGA,6CAAA;EACA,gBAAA;EACA,iBAAA;AAxBJ;AA0BE;EACE,oCC7QW;ED8QX,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AAxBJ;AA0BE;EACE,YAAA;EACA,oCCzRW;ED0RX,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;AAxBJ;AA0BE;EACE,oBAAA;AAxBJ;AA0BE;EACE,oBAAA;AAxBJ;AA0BE;EACE,oCC1SW;ED2SX,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAxBJ;AAyBI;EACE,UAAA;AAvBN;AA0BE;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AAxBJ;AA0BE;EACE,YAAA;AAxBJ;;AA2BA;EACE;IACE,aAAA;IACA,mBAAA;EAxBF;EA0BA;IACE,qBAAA;EAxBF;EAyBE;IACE,eAAA;EAvBJ;EAyBE;IACE,aAAA;IACA,eAAA;IACA,4BAAA;EAvBJ;AACF;AA0BA;EAEI;IACE,4BAAA;IACA,cAAA;IACA,YAAA;EAzBJ;AACF;AA4BA;EAEI;IACE,4BAAA;EA3BJ;AACF;AA8BA;EAEI;IACE,eAAA;EA7BJ;EA+BE;IACE,UAAA;EA7BJ;EA+BE;IACE,eAAA;EA7BJ;AACF;AAiCA;EAEI;IACE,aAAA;IACA,4BAAA;IACA,gBAAA;IACA,cAAA;EAhCJ;AACF;AAmCA;EACE;IACE,eAAA;EAjCF;AACF;AAmCA;EACE,cAAA;AAjCF;;AAmCA;EACE;IACE,6BAAA;EAhCF;EAkCA;IACE,sBAAA;IACA,uBAAA;EAhCF;EAkCA;IACE,sBAAA;IACA,uBAAA;EAhCF;EAkCA;IACE,kBAAA;IACA,6BAAA;EAhCF;EAkCA;IACE,mBAAA;EAhCF;EAkCA;IACE,6BAAA;EAhCF;EAkCA;IACE,WAAA;EAhCF;AACF;AAkCA;EACE,qBAAA;EACA,0BAAA;EACA,gBAAA;AAhCF;;AAkCA;EACE;IACE,mBAAA;EA/BF;AACF;AAiCA;EACE;IACE,6BAAA;IACA,eAAA;IACA,0BAAA;EA/BF;AACF;AAiCA;EACE;IACE,0BAAA;EA/BF;AACF;AAiCA;EACE;IACE,0BAAA;EA/BF;AACF;AAiCA;EACE,wCAAA;AA/BF;;AAkCA;EACE;IACE,0BAAA;EA/BF;EAiCA;IACE,0BAAA;EA/BF;EAiCA;IACE,eAAA;EA/BF;AACF;AAiCA;EACE;IACE,eAAA;EA/BF;AACF;AAiCA;EACE;IACE;MACE,0BAAA;IA/BF;IAiCA;MACE,0BAAA;IA/BF;IAiCA;MACE,0BAAA;IA/BF;EACF;AACF","sourcesContent":["@use \"src/styles/variables\" as var;\n@use \"src/containers/ChooseAFlight/themevariable.scss\" as theme;\n\n.FlightListCard {\n  margin-top: 10px;\n  width: 453px;\n  //background:#ffffff;\n\n  .product-box {\n    padding: 0;\n    border: 1px solid #e7eaec;\n  }\n\n  .product-box.active {\n    // border: 2px solid #d37cb9;\n    -webkit-box-shadow: (0px 10px 20px rgba(0, 0, 0, 0.15));\n    -moz-box-shadow: (0px 10px 20px rgba(0, 0, 0, 0.15));\n    box-shadow: (0px 10px 20px rgba(0, 0, 0, 0.15));\n  }\n  @media screen and (max-width: 451px) {\n    .product-box.active {\n      box-shadow: none;\n    }\n  }\n  .product-imitation {\n    text-align: center;\n    padding: 6px 0;\n  }\n  .product-imitation img {\n    /*height: 160px;*/\n    // max-width: 100%;\n    width: 100%;\n    height: 199px;\n    object-fit: cover;\n  }\n  .product-header {\n    margin-bottom: 10px;\n  }\n  .product-header .header-img-1 img {\n    // width: 110px;\n    // height: 23px;\n    width: 50%;\n  }\n  .header-img-2 {\n    // float: right;\n    cursor: pointer;\n    width: fit-content;\n    margin-left: auto;\n  }\n  .header-img-2 img {\n    width: 20px;\n    height: 20px;\n    vertical-align: text-top;\n    margin-right: 11px;\n  }\n  span.header-img-2 span {\n    vertical-align: top;\n    padding-left: 2px;\n    vertical-align: top;\n    padding-left: 2px;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 24px;\n    text-align: center;\n    color: #694779;\n    opacity: 0.8;\n  }\n  .product-name {\n    font-family: var.$font-regular;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 19px;\n    line-height: 31px;\n    color: #000000;\n    padding-bottom: 20px;\n  }\n  .product-deatils-col span {\n    width: 19px;\n    flex: none;\n    flex-grow: 0;\n    margin-right: 18px;\n    font-size: 11.2px;\n  }\n  @media screen and (max-width: 575px) {\n    .product-bottom {\n      padding-top: 0px !important;\n    }\n    .product-deatils-col span {\n      font-size: 15px;\n    }\n    .product-deatils-col {\n      font-size: 15px !important;\n    }\n    .product-bottom span {\n      font-size: 14px !important;\n      line-height: 18px !important;\n    }\n  }\n  .product-deatils-col span img {\n    filter: invert(0%) brightness(0%);\n    margin-bottom: 3px;\n  }\n  .product-desc {\n    padding: 20px 0px 15px 11px;\n    position: relative;\n  }\n  .product-bottom {\n    clear: both;\n    display: flex;\n    margin-left: 9px;\n    padding-top: 7px;\n  }\n  .product-deatils {\n    width: 100%;\n  }\n  .product-deatils-col {\n    width: 50%;\n    float: left;\n    font-family: var.$font-regular;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    color: #000000;\n    flex: none;\n    order: 1;\n    flex-grow: 0;\n    height: 26px;\n    margin-bottom: 18px;\n  }\n  .product-bottom span {\n    font-family: var.$font-regular;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    color: #694779;\n    cursor: pointer;\n    letter-spacing: 0.2px;\n  }\n  .product-bottom button {\n    background: #ffffff;\n    border: 1px solid #694779;\n    border-radius: 70px;\n    // &:hover {\n    //   background: #694779 !important;\n    //   color: $customFontColor !important;\n    // }\n    // &:active {\n    //   background: #694779 !important;\n    //   color: $customFontColor !important;\n    // }\n    // &:visited {\n    //   background: #694779 !important;\n    //   color: $customFontColor !important;\n    // }\n  }\n  .ecommerce .tag-list {\n    padding: 0;\n  }\n  .ecommerce .fa-star {\n    color: #d1dade;\n  }\n  .ecommerce .fa-star.active {\n    color: #f8ac59;\n  }\n  .ecommerce .note-editor {\n    border: 1px solid #e7eaec;\n  }\n  table.shoping-cart-table {\n    margin-bottom: 0;\n  }\n  table.shoping-cart-table tr td {\n    border: none;\n    text-align: right;\n  }\n  table.shoping-cart-table tr td.desc,\n  table.shoping-cart-table tr td:first-child {\n    text-align: left;\n  }\n  table.shoping-cart-table tr td:last-child {\n    width: 80px;\n  }\n  .product-detail .ibox-content {\n    padding: 30px 30px 50px 30px;\n  }\n  .image-imitation {\n    background-color: #f8f8f9;\n    text-align: center;\n    padding: 200px 0;\n  }\n\n  .ibox {\n    clear: both;\n    margin-bottom: 25px;\n    margin-top: 0;\n    padding: 0;\n  }\n  @media screen and (max-width: 451px) {\n    .ibox {\n      margin-bottom: 0px;\n    }\n  }\n  .ibox.collapsed .ibox-content {\n    display: none;\n  }\n\n  .ibox:after,\n  .ibox:before {\n    display: table;\n  }\n  .ibox-title {\n    -moz-border-bottom-colors: none;\n    -moz-border-left-colors: none;\n    -moz-border-right-colors: none;\n    -moz-border-top-colors: none;\n    background-color: #ffffff;\n    border-color: #e7eaec;\n    border-image: none;\n    border-style: solid solid none;\n    border-width: 3px 0 0;\n    color: inherit;\n    margin-bottom: 0;\n    padding: 14px 15px 7px;\n    min-height: 48px;\n  }\n  .ibox-content {\n    background-color: #ffffff;\n    color: inherit;\n    padding: 15px 20px 0px 20px;\n    border-color: #e7eaec;\n    border-image: none;\n  }\n  @media screen and (max-width: 575px) {\n    .ibox-content {\n      padding: 15px 16px 0px 16px;\n    }\n    .product-header {\n      margin-bottom: 3px;\n      margin-top: -5px;\n    }\n    .product-desc {\n      padding: 9px 0px 9px 11px;\n    }\n  }\n  .ibox-footer {\n    color: inherit;\n    border-top: 1px solid #e7eaec;\n    font-size: 90%;\n    background: #ffffff;\n    padding: 10px 15px;\n  }\n}\n\n.popover-positioned-top {\n  border: none !important;\n  .pop-top {\n    // padding-bottom: 6px;\n    margin-bottom: 30px;\n  }\n  .pop-top .popover-title {\n    font-size: 20px;\n    font-weight: 700;\n  }\n  .popover-body {\n    min-width: 549px;\n    padding: 0;\n    border: none;\n    margin: 0;\n  }\n  .popover-con {\n    padding: 30px;\n    background: #ffffff;\n    border: 1px solid transparent;\n    -webkit-box-shadow: (0px 10px 20px rgba(0, 0, 0, 0.15));\n    -moz-box-shadow: (0px 10px 20px rgba(0, 0, 0, 0.15));\n    box-shadow: (0px 10px 20px rgba(0, 0, 0, 0.15));\n    min-width: 549px;\n    margin-left: 75px;\n  }\n  .top-name {\n    font-family: var.$font-regular;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 31px;\n    display: flex;\n    align-items: center;\n    color: #000000;\n    float: left;\n  }\n  .top-tail {\n    float: right;\n    font-family: var.$font-regular;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #848b94;\n    flex-direction: row-reverse;\n  }\n  .pop-top {\n    padding-bottom: 10px;\n  }\n  .pop-middle {\n    padding-bottom: 15px;\n  }\n  .pop-body {\n    font-family: var.$font-regular;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: #000;\n    display: flex;\n    flex-wrap: wrap;\n    column-gap: 30px;\n    row-gap: 10px;\n    > .details-item {\n      width: 45%;\n    }\n  }\n  label.lbltxt {\n    width: 50%;\n    float: left;\n    margin-bottom: 0;\n  }\n  span.lblval {\n    float: right;\n  }\n}\n@media screen and (var.$mobile-media) {\n  .FlightListCard {\n    padding: 15px;\n    padding-bottom: 0px;\n  }\n  .popover-positioned-top {\n    z-index: 1 !important;\n    .popover-body {\n      min-width: 100%;\n    }\n    .popover-con {\n      padding: 23px;\n      min-width: 100%;\n      margin-left: 15px !important;\n    }\n  }\n}\n@media screen and (var.$tablet-media-min) and (max-width: 575px) {\n  .popover-positioned-top {\n    .popover-con {\n      margin-left: 20px !important;\n      min-width: 0px;\n      width: 360px;\n    }\n  }\n}\n@media screen and (min-width: 1200px) and (max-width: 1439px) {\n  .popover-positioned-top {\n    .popover-con {\n      margin-left: 20px !important;\n    }\n  }\n}\n@media screen and (var.$tablet-media-min) and (var.$tablet-media) {\n  .FlightListCard {\n    .product-name {\n      font-size: 18px;\n    }\n    .product-header .header-img-1 img {\n      width: 50%;\n    }\n    .Button.small-btn {\n      font-size: 12px;\n    }\n  }\n}\n\n@media screen and (min-width: 576px) and (max-width: 850px) {\n  .popover-positioned-top {\n    .popover-con {\n      padding: 23px;\n      margin-left: 75px !important;\n      max-width: 360px;\n      min-width: 0px;\n    }\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 1200px) {\n  .FlightListCard .product-deatils-col {\n    font-size: 11px;\n  }\n}\n.product-details-color {\n  color: #000000;\n}\n@media screen and (max-width: 575px) {\n  .max-passengers-span-style {\n    margin-bottom: 6px !important;\n  }\n  .max-passengers-width {\n    width: 26px !important;\n    height: 16px !important;\n  }\n  .wifi-icon-width {\n    width: 23px !important;\n    height: 16px !important;\n  }\n  .currency-img-padding {\n    padding-left: 11px;\n    margin-bottom: 0px !important;\n  }\n  .product-deatils-col {\n    margin-right: -40px;\n  }\n  .currency-vector-mob-margin {\n    margin-right: 16px !important;\n  }\n  .popover-positioned-top .pop-body > .details-item {\n    width: 100%;\n  }\n}\n.letter-spacing-style {\n  letter-spacing: 0.1px;\n  font-size: 14px !important;\n  font-weight: 600;\n}\n@media screen and (min-width: 1200px) {\n  .product-deatils-col {\n    margin-right: -49px;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .span-margin-style {\n    margin-right: 15px !important;\n    margin-top: 2px;\n    font-size: 14px !important;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .product-name {\n    font-size: 24px !important;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .max-passengers-span-style {\n    font-size: 16px !important;\n  }\n}\n.popover-positioned-top {\n  background-color: transparent !important;\n}\n\n@media screen and (min-width: 768px) and (max-width: 820px) {\n  .FlightListCard .product-name {\n    font-size: 20px !important;\n  }\n  .FlightListCard .product-deatils-col {\n    font-size: 16px !important;\n  }\n  .FlightListCard .product-deatils-col span {\n    font-size: 13px;\n  }\n}\n@media screen and (min-width: 891px) and (max-width: 1024px) {\n  .FlightListCard .product-name {\n    font-size: 17px;\n  }\n}\n@supports (-webkit-touch-callout: none) {\n  @media (min-width: 1200px) {\n    .product-name {\n      font-size: 20px !important;\n    }\n    .trip-estimate-title {\n      font-size: 20px !important;\n    }\n    .TripSummary .subtitile-h4 {\n      font-size: 18px !important;\n    }\n  }\n}\n","$page-width: 968px;\n$page-short-width: 700px;\n$black: #000;\n$white: #fff;\n$yellow: #ebff0c;\n$blue: #3881ef;\n$blue1:#4782E7;\n$red: #ef3838;\n$dark-blue: #1d6add;\n$grey1: #f1f4f9;\n$grey2: #cfcdcd;\n$grey3: #848b94;\n$grey4: #d5dce7;\n$grey5: #2c3034;\n$grey6: #535a61;\n$grey7: #9ca2a9;\n$grey8: #666d74;\n\n$font-regular: 'FKGroteskNeue-Regular';\n$font-medium: 'FKGroteskNeue-Medium';\n$font-bold: 'FKGroteskNeue-Bold';\n$mobile-media: 'max-width: 451px';\n$tablet-media-min: 'min-width: 451px';\n$tablet-media: 'max-width: 800px';\n$tablet-media-min-hz: 'min-width: 800px';\n$tablet-media-hz: 'max-width: 1200px';\n\n// Guide Color Code ----------------------------------\n\n$primary-black: #000000;\n$primary-white: #FFFFFF;\n$primary-gray: #F1F4F9;\n$secondary-yellow: #EBFF0C;\n$secondary-skyblue: #3881EF;\n$secondary-darkblue: #1D6ADD;\n$light-gray1: #F1F4F9;\n$light-gray2: #D5DCE7;\n$light-gray3: #848B94;\n$dark-gray1: #2C3034;\n$dark-gray2: #535A61;\n$dark-gray3: #9CA2A9;\n$error-red: #EF3838;\n$success-green : #AAFE3F;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
